import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Box, TextButton } from '@zillow/constellation';
import { usePageProps } from '../PagePropsProvider/PagePropsProvider.js';
import { yieldCallback } from '@zillow/yield-callback';
import { getCmsInfoForPage } from '../../utils/clickstream/getCmsInfoForPage.js';
import { sendEvent } from './B2BUserNav.utils.js';

var TextButtonAnchor = function TextButtonAnchor(props) {
  return /*#__PURE__*/React.createElement(TextButton, _extends({
    as: "a",
    fontType: "bodySmall"
  }, props));
};
var SignOut = function SignOut(_ref) {
  var url = _ref.url,
    dropdown = _ref.dropdown;
  var pageProps = usePageProps();
  var cmsInfo = getCmsInfoForPage(pageProps);
  return /*#__PURE__*/React.createElement(Box, {
    as: "ul",
    "aria-expanded": dropdown,
    sx: {
      position: 'absolute',
      display: dropdown ? 'block' : 'none',
      ariaEpanded: dropdown ? 'true' : 'false',
      top: 'calc(100% + 4px)',
      right: 'calc($spacing.xs * -1)',
      margin: 0,
      minWidth: 'calc($spacing.md * 5)',
      padding: 0,
      backgroundColor: '$colors.backgroundWhite',
      borderRadius: '$radii.md',
      boxShadow: '$shadows.shadow200',
      fontSize: '$fontSizes.body',
      fontWeight: '$fontWeights.body',
      zIndex: '$zIndices.popover',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: "li",
    sx: {
      padding: '$spacing.xxs $spacing.sm',
      listStyle: 'none',
      ':hover': {
        backgroundColor: '$colors.backgroundBlue'
      }
    }
  }, /*#__PURE__*/React.createElement(TextButtonAnchor, {
    href: url,
    onClick: yieldCallback(function () {
      sendEvent('cms_anchor', 'Sign Out', url, cmsInfo);
    })
  }, "Sign Out")));
};
var SignOut$1 = SignOut;

export { SignOut$1 as default };
